export const GET_ALL_UNREAD_NOTIFICATIONS_LOADING = "GET_ALL_UNREAD_NOTIFICATIONS_LOADING"
export const GET_ALL_UNREAD_NOTIFICATIONS_DATA = "GET_ALL_UNREAD_NOTIFICATIONS_DATA"
export const GET_ALL_UNREAD_NOTIFICATIONS_FAILED = "GET_ALL_UNREAD_NOTIFICATIONS_FAILED"